// extracted by mini-css-extract-plugin
export default {"mobileAccordionMenu":"MobileAccordionMenu-mobileAccordionMenu--d99f5","mobileAccordionMenuList":"MobileAccordionMenu-mobileAccordionMenuList--472e0"};